export default "__VITE_ASSET__D6onXva7__"